@if (!!account) {
  <ul class="params">
    @if (isCredentialsVisible) {
      <li class="params__item">
        <span class="params__title">
          {{ 'account.label.server' | translate }}
        </span>
        <span class="params__value">
          <span data-qa="dashboard.account-server.text">{{account.server.name}}</span>
          <tooltip-copy-link
            type="icon"
            [copiedTooltipLabel]="'register-account-certificate.tooltip.copied' | translate"
            [text]="account.server.name || ''"
          />
        </span>
      </li>
      <li class="params__item">
        <span class="params__title">
          {{ 'account.label.login' | translate }}
        </span>
        <span class="params__value">
          <span data-qa="dashboard.account-login.text">{{account.login}}</span>
          <tooltip-copy-link
            type="icon"
            [copiedTooltipLabel]="'register-account-certificate.tooltip.copied' | translate"
            [text]="account.login.toString()"
          />
        </span>
      </li>
      <li class="params__item">
        <span class="params__title">
          {{ 'account.label.password' | translate }}
        </span>
        <global-account-viewer-password
          class="params__value"
          [account]="account"
        />
      </li>
    }
    @if (isFixRateVisible) {
      <li class="params__item">
        <span class="params__title">
          {{ 'dashboard.label.fix-rate' | translate }}
          <svg-icon-sprite
            height="14px"
            src="./assets/img/icons/sprite.svg#hint"
            width="14px"
            [matTooltip]="'account.tooltip.fixrate' | translate: { rate: fixedRate, currency: fixRateCurrency }"
            [matTooltipPosition]="'above'"
          />
        </span>
        <toggler
          class="params__value"
          [attr.data-qa]="'dashboard.account-fix-rate.toggle'"
          [checked]="account.isFixRate"
          [disabled]="true"
        />
      </li>
    }
    <li class="params__item">
      <span class="params__title" translate="account.label.leverage"></span>
      <global-account-viewer-leverage
        class="params__value"
        [account]="account"
      />
    </li>
    @if (isSwapFreeVisible) {
      <li class="params__item">
        <span class="params__title">
          {{ swapFreeLabel$ | async | translate }}
          <svg-icon-sprite
            height="14px"
            src="./assets/img/icons/sprite.svg#hint"
            width="14px"
            [matTooltip]="'account.tooltip.swapfree' | translate"
            [matTooltipPosition]="'above'"
          />
        </span>
        <global-account-viewer-swap-free
          class="params__value"
          [account]="account"
        />
      </li>
    }
  </ul>
}
